import { Wording } from '@/types';

export const YOGA_WORDING_BA: Wording = {
  components_header_media_content: 'Vježbe',
  components_header_media_1: '',
  components_header_text1: 'Recepti',
  components_header_text2: 'Blog',
  components_header_members: 'Članovi',
  hero_text: 'Održavajte svoje tijelo fleksibilnim i jakim',
  hero_button_text: 'Započnite svoje joga putovanje',
  components_ressources_section_title: 'RESURSI',
  components_ressources_subheader_text: 'Svi resursi koji su vam potrebni za skladan način života',
  components_ressources_span_text: 'Otkrijte tajne blagostanja: Zaronite u kolekciju joga poza, svjesnih meditacija i zdravih recepata za stvaranje ravnoteže u svakom aspektu vašeg života.',
  components_ressources_card_1_title: 'Savjeti za jogu',
  components_ressources_card_1_text: 'Praktični savjeti za produbljivanje vaše prakse i usavršavanje vaših poza.',
  components_ressources_card_2_title: 'Dijeta',
  components_ressources_card_2_text: 'Pametni savjeti za ishranu za zdravijeg i jačeg sebe.',
  components_ressources_link: 'Gledajte videozapise',
  components_notes_and_google_title_1: 'Vježbe joge',
  components_notes_and_google_title_2: 'Redovna rutina',
  components_notes_and_google_title_3: 'Održavanje dijete',
  components_review_google_text: 'Recenzija na Googleu',
  media_content_section_title: 'TRENING',
  media_content_section_subheader_text: 'Naši videozapisi',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Više videa',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Članci i vijesti',
  text2_section_button_more: 'Više članaka',
  components_text1_section_title: 'RECEPTI',
  components_text1_subheader_text: 'Nahranite svoje tijelo i um',
  components_text1_span_text: 'Zdravi recepti za podršku vašoj praksi joge i poboljšanje vašeg blagostanja.',
  components_text1_card_1_title: 'Energični doručci',
  components_text1_card_1_text: 'Probudite se uz živahne obroke koji podižu energiju.',
  components_text1_card_3_title: 'Ručkovi puni energije',
  components_text1_card_3_text: 'Otkrijte ukusne i praktične recepte za ručak osmišljene za vaš aktivan način života. Od šarenih salata do tortilja bogatih proteinima, ovi recepti će vam dati energiju i održati fokus.',
  components_text1_card_2_title: 'Večere za oporavak',
  components_text1_card_2_text: 'Istražite razne nemasne proteine, cjelovite žitarice i živahno povrće za zadovoljavajući kraj dana.',
  components_text1_link: 'Pogledajte sve recepte',
  components_footer_text: 'Pronađite ravnotežu, duboko dišite: Vaša joga, vaše putovanje.',
  components_footer_info: 'Informacije',
  components_footer_registration_number: 'Registarski broj',
  components_footer_legal: 'Pravno',
  components_footer_terms: 'Uslovi i odredbe',
  components_footer_privacy: 'Politika privatnosti',
  button_load_more: 'Učitaj više',
  page_media_1_content_hero_text: 'Joga vježbe',
  page_text1_hero_text: 'Recepti',
  page_text1_section_title: 'Ishrana',
  page_text1_subheader_text: 'Recepti',
  page_text2_hero_text: 'Naš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Članci i vijesti',
  enter_email_title: 'Molimo unesite svoju e-mail adresu da biste nastavili',
  enter_email_placeholder_email: 'E-pošta',
  enter_email_button_enter: 'Unesi',
  components_login_success_text: 'Prijava uspješna!',
  components_card_link_media_content: 'Gledajte sada',
  components_card_link_text1_content: 'Pogledajte recept',
  components_card_link_text2_content: 'Pogledajte članak',
};